// removed by extract-text-webpack-plugin
module.exports = {"pgx-warning-tip":"pgx-warning-tip","ant-tooltip-inner":"ant-tooltip-inner","edited-history-single":"edited-history-single","column":"column","edited-wrap":"edited-wrap","edited-warning":"edited-warning","text":"text"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/WarningTip/WarningTip.scss
// module id = 924
// module chunks = 0